import { responsiveConstant } from '@app/Dashboard/constants';
import MobileLibrary from './components/MobileLibrary';
import WebLibrary from './components/WebLibrary';

const TadatoonLibrary = () => {
  const width = window.innerWidth;

  return (
    <div>{width > responsiveConstant ? <WebLibrary /> : <MobileLibrary />}</div>
  );
};

export default TadatoonLibrary;
